import Vue from 'vue';

const tokenRefreshBefore = 10 * 60 * 1000;

const decodeToken = function (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};

const setToken = (commit, token) => {
    localStorage.setItem('user-token', token);
    Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    commit('setToken', token);
};

const successAuth = (commit, dispatch, authData) => {
    setToken(commit, authData.token);
    writeUserToLocalStorage(authData.user);
    commit('setUser', authData.user);
};

const writeUserToLocalStorage = user => {
    localStorage.setItem('user', JSON.stringify(user));
};

const clearAuth = (commit) => {
    localStorage.removeItem('user-token');
    commit('setToken', null);
};

export default {
    signIn: ({ state, commit, dispatch }, payload) => {
        return Vue.prototype.$http.post('/api/v1/auth/login', {
            email: payload.email,
            password: payload.password,
        })
            .then(response => {
                successAuth(commit, dispatch, response.data);

                return dispatch('initRefreshToken');
            })
            .catch(error => {
                clearAuth(commit);
                throw error;
            });
    },

    refreshToken({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            commit('setCheckingToken', true);
            Vue.prototype.$http.get('/api/v1/auth/refresh')
                .then(response => {
                    let token = response.data.token;
                    setToken(commit, token);

                    let decodedToken = decodeToken(token);
                    let expiration = new Date(decodedToken.exp * 1000);
                    let timeToRefresh = expiration - (new Date()) - tokenRefreshBefore;
                    let refreshToken = () => dispatch('refreshToken');

                    setTimeout(refreshToken, timeToRefresh);

                    commit('setCheckingToken', false);

                    resolve(response);
                })
                .catch(error => {
                    // console.error('ERROR REFRESHING TOKEN', error);
                    clearAuth(commit);
                    commit('setCheckingToken', false);
                    reject(error)
                });
        })
    },

    initRefreshToken({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            let token = localStorage.getItem('user-token');

            if (!token || token === 'undefined') {
                clearAuth(commit);
                commit('setCheckingToken', false);
                throw new Error('No token stored');
            }

            let decodedToken = decodeToken(token);
            let expiration = new Date(decodedToken.exp * 1000);
            let now = new Date();
            let refreshToken = () => dispatch('refreshToken');

            if (now >= expiration - tokenRefreshBefore) {
                return refreshToken();
            } else {
                const timeToRefresh = expiration - now - tokenRefreshBefore;
                setToken(commit, token);
                commit('setCheckingToken', false);
                setTimeout(refreshToken, timeToRefresh);
            }

            resolve();
        });
    },

    fetchUser({ commit }) {
        return Vue.prototype.$http.get('/api/v1/auth/me')
            .then(response => {
                const { user } = response.data;
                writeUserToLocalStorage(user);
                commit('setUser', user);
            });
    },

    logout({ commit }) {
        return Vue.prototype.$http.get('/api/v1/auth/logout')
            .then(response => {
                clearAuth(commit);
            })
    },
};
